import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { shiftTotalSchema } from '../types';

export const receiveShiftClosed = createReceive('shift-closed', zodContract(shiftTotalSchema));
